import styled from "styled-components";


export const Container = styled.div`
  margin-top: 70px;
  max-width: 100vw;
`;
